import _typeof from "babel-runtime/helpers/typeof";


import Qs from "qs";
import baseConfig from "./baseConfig";

var axiosConfig = {

  url: "/",
  method: "POST",
  baseURL: baseConfig.$basecfg.httpConfig.baseUrl,
  transformRequest: [function (data) {
    if (typeof data == "string") {
      return data;
    } else if ((typeof data === "undefined" ? "undefined" : _typeof(data)) == "object") {
      data = Qs.stringify(data);
      return data;
    }
  }],

  transformResponse: [function (data) {
    try {
      if (typeof data == "string") {
        data = JSON.parse(data);
        return data;
      } else if ((typeof data === "undefined" ? "undefined" : _typeof(data)) == "object") {
        return data;
      }
    } catch (error) {
      consoleError("axios拦截响应数据JSON格式化失败，原因：" + error);
    }
  }],

  headers: {
    "Content-Type": "text/plain; charset=utf-8"
  },

  params: {},

  paramsSerializer: function paramsSerializer(params) {
    return Qs.stringify(params);
  },

  data: {},

  timeout: 100000,
  retryDelay: 1000,
  retry: 0,
  withCredentials: false,
  responseType: "json",
  maxContentLength: 20000,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  maxRedirects: 5 };

var plugin = {
  install: function install(Vue) {
    Vue.axioscfg = axiosConfig;

    Vue.prototype.$axioscfg = axiosConfig;
  },

  $axioscfg: axiosConfig
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/config/axiosConfig.js
// module id = 390
// module chunks = 2